import {
    ConfigKeySchema,
    EnvironmentRecordSchema,
    EnvironmentSchema,
    QuestionnaireElementSchema,
    QuestionnaireItems,
    SiteConfigSchema,
    ThemeSchema,
} from 'embed/schemas'
import {
    Environment, Variant,
} from 'appconfig'
import {EmbedEvent} from './events'

import {z} from 'zod'

export type NinchatEmbedConfig = {
    parentUrl?: string
    targetOrigin: string
    ssoAccessKey?: string
    isWebView?: boolean
}

export type NinchatEventData = object

export interface NinchatEventCallback {
    (data: NinchatEventData): void
}

export type NinchatCallbacks = Record<EmbedEvent | 'all_events', NinchatEventCallback[]>

export type NinchatConfigKey = z.infer<typeof ConfigKeySchema>

export type NinchatEmbedEnvironment = string[]

export type NinchatEnvironment = z.infer<typeof EnvironmentRecordSchema>

export type NinchatEnvironmentConfig = z.infer<typeof EnvironmentSchema>

export type NinchatEnvironmentConfigTheme = z.output<typeof ThemeSchema>
export type NinchatEnvironmentConfigThemeIn = z.input<typeof ThemeSchema>
// Explicit type for the runtime schema of Theme
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface NinchatEnvironmentConfigThemeRT extends z.ZodType<NinchatEnvironmentConfigTheme, z.ZodTypeDef, NinchatEnvironmentConfigThemeIn> {}

export type NinchatEnvironmentConfigQuestionnaireItems = z.output<typeof QuestionnaireItems>
export type NinchatEnvironmentConfigQuestionnaireItemsIn = z.input<typeof QuestionnaireItems>
export type NinchatEnvironmentConfigQuestionnaireItemsRT = z.ZodType< NinchatEnvironmentConfigQuestionnaireItems, z.ZodTypeDef, NinchatEnvironmentConfigQuestionnaireItemsIn>

export type NinchatQuestionnaireElement = z.infer<typeof QuestionnaireElementSchema>

export type NinchatSiteConfig = z.infer<typeof SiteConfigSchema>

export type NinchatOptions = {
    [key: string]: any
    config?: NinchatSiteConfig
    configKey: NinchatConfigKey
    configUrls?: string[]
    containerId?: string
    environment: NinchatEmbedEnvironment
    mode?: Environment
    postConfigUrls?: string[]
    targetOrigin: string
    variant?: Variant
    version: string
    siteSecret?: string
    isWebView?: boolean
    restoredStorage?: Record<string, string>
}

export const NinchatOptionsSchema = z.object({
    config: z.object({}).passthrough()
        .optional(),
    configKey: ConfigKeySchema,
    configUrls: z.array(z.string()).optional(),
    containerId: z.string().optional(),
    environment: z.array(z.string()),
    isWebView: z.boolean().optional(),
    postConfigUrls: z.array(z.string()).optional(),
    siteSecret: z.string().optional(),
    targetOrigin: z.string(),
    variant: z.string().optional(),
    version: z.string(),
}).passthrough()
